import React from 'react'
import { Link } from 'react-scroll'
import { HashLink } from 'react-router-hash-link'

const Footer = () => {
  return (
    <div
      style={{ background: '#15161D' }}
      className='w-full text-base py-20 border-t-4 border-red-500 mt-15 text-gray-400'
    >
      <div className='flex flex-wrap justify-center md:justify-between md:w-11/12 lg:w-9/12 xl:w-7/12 w-full mx-auto gap-x-5 lg:gap-x-10 xxl:gap-x-20 gap-y-5'>
        <div style={{ minWidth: '250px' }} className='w-56'>
          <h2 className='font-bold text-2xl text-white w-full mb-5'>ABOUT US</h2>
          <p className='text-base w-full mb-5'>
            We are your plug for all brands of mobile phones and Accessories. Buy online and get
            your items shipped to you in the shortest time possible
          </p>
          <p className='hover:text-red-800 cursor-pointer'>
            <i className='fa fa-map-marker scale-125 text-red-500 mr-3'></i>Visit us
          </p>
          <p className='hover:text-red-800 my-5 cursor-pointer'>
            <i className='fa fa-phone scale-125 text-red-500 mr-3'></i>347-374-8005
          </p>
          <p className='hover:text-red-800 cursor-pointer'>
            <i className='fa fa-envelope-o scale-125 text-red-500 mr-3'></i>info@wirelessstore.com
          </p>
        </div>
        <div style={{ minWidth: '250px' }} className='w-56'>
          <h2 className='font-bold text-2xl text-white w-full mb-5'>CATEGORIES</h2>

          <p className='py-1'>
              <Link
                className='hover:text-red-800 my-2 cursor-pointer text-gray-400'
                activeClass='active'
                to='smartphones'
                spy
                smooth
                offset={-130}
                duration={500}
              >
                Smartphones
              </Link>
            </p>
          <p className='py-1'>
            <Link className='hover:text-red-800 my-2 cursor-pointer text-gray-400' activeClass='active' to='tablets' spy smooth offset={-130} duration={500}>
                    Tablet Phones
              </Link></p>
          <p className='py-1'>
            <Link
              className='hover:text-red-800 my-2 cursor-pointer text-gray-400'
              activeClass='active'
              to='accessories'
              spy
              smooth
              offset={-130}
              duration={500}
            >
              Accessories
            </Link>
          </p>
          <p className='py-1'>
            <Link className='hover:text-red-800 my-2 cursor-pointer text-gray-400' activeClass='active' to='latest' spy smooth offset={-130} duration={500}>
              Latest Items
            </Link>
          </p>
        </div>
        <div style={{ minWidth: '250px' }} className='w-56'>
          <h2 className='font-bold text-2xl text-white w-full mb-5'>INFORMATION</h2>

          <p className='hover:text-red-800 my-2 cursor-pointer'>
            <HashLink
              className='text-gray-400'
              activeClass='active'
              to='/#about'
              spy
              smooth
              offset={-130}
              duration={500}
            >
              About Us
            </HashLink></p>
          <p className='hover:text-red-800 my-2 cursor-pointer'>
            <HashLink
              className='text-gray-400'
              activeClass='active'
              to='/#contact'
              spy
              smooth
              offset={-130}
              duration={500}
            >
              Contact Us
            </HashLink></p>
        </div>
      </div>
    </div>
  )
}

export default Footer
